const cameraLanguage = {
	//Задняя
	back: [
		"Задняя", //Русский
		"Задней", //Русский
		"Зад", //Русский
		"e pasme", //Албанский
		"rear", //Английский
		"back", //Английский
		"atzekoa", //Баскский
		"задні", //Белорусский
		"отзад", //Болгарский
		"pozadi", //Боснийский
		"cefn", //Валлийский
		"hátulsó", //Венгерский
		"traseira", //Галисийский
		"achterkant", //Голландский
		"όπισθεν", //Греческий
		"bag", //Датский
		"דערציען", //Идиш
		"cúil", //Ирландский
		"aftan", //Исландский
		"trasero", //Испанский
		"posteriore", //Итальянский
		"posterior", //Каталонский
		"aizmugure", //Латышский
		"galinis", //Литовский
		"задниот дел", //Македонский
		"wara", //Мальтийский
		"hinteren", //Немецкий
		"bak", //Норвежский
		"tył", //Польский
		"tyl", //Польский
		"traseira", //Португальский
		"spate", //Румынский
		"задњи", //Сербский
		"zadný", //Словацкий
		"zadaj", //Словенский
		"задній", //Украинский
		"takaosa", //Финский
		"arrière", //Французский
		"straga", //Хорватский
		"zadní", //Чешский
		"bak", //Шведский
		"tagumine", //Эстонский
		"environment", //
		"arxa", //Азербайджанский
		"թիկունք", //Армянский
		"পিছনে", //Бенгальский
		"နောက်ဘက်", //Бирманский
		"ở phía sau", //Вьетнамский
		"უკანა", //Грузинский
		"પાછળ", //Гуджарати
		"артқы", //Казахский
		"ಹಿಂದಿನ", //Каннада
		"後部", //Китайский (Традиционный)
		"后部", //Китайский (Упрощенный)
		"뒤쪽", //Корейский
		"ខាងក្រោយ", //Кхмерский
		"ຫລັງ", //Лаосский
		"പുറകിലുള്ള", //Малаялам
		"मागील", //Маратхи
		"арын", //Монгольский
		"पछाडि", //Непальский
		"පසුපස", //Сингальский
		"пушти", //Таджикский
		"หลัง", //Тайский
		"பின்புறம்", //Тамильский
		"వెనుక", //Телугу
		"arka", //Турецкий
		"orqa", //Узбекский
		"پیچھے", //Урду
		"पिछला", //Хинди
		"qab", //Хмонг
		"後方", //Японский
		"مؤخرة", //Арабский
		"חלק אחורי", //Иврит
		"عقب", //Персидский
		"agter", //Африкаанс
		"ngemuva", //Зулу
		"azụ", //Игбо
		"leyin", //Йоруба
		"kamorao", //Сесото
		"gadaale", //Сомалийский
		"nyuma", //Суахили
		"baya", //Хауса
		"kumbuyo", //Чева
		"belakang", //Индонезийский
		"aoriana", //Малагасийский
		"belakang", //Малайский
		"muri", //Маори
		"luyo", //Себуано
		"likuran", //Филиппинский
		"mburi", //Яванский
		"dèyè", //Гаитянский Креольский
		"tergo", //Латынь
		"malantaŭo", //Эсперанто
	],

	//Передняя
	front: [
		"FaceTime", // Apple bypass
		"Передняя", //Русский
		"përpara", //Албанский
		"front", //Английский
		"aurrean", //Баскский
		"пярэдні", //Белорусский
		"отпред", //Болгарский
		"front", //Боснийский
		"blaen", //Валлийский
		"elülső", //Венгерский
		"diante", //Галисийский
		"voorkant", //Голландский
		"εμπρός", //Греческий
		"foran", //Датский
		"פראָנט", //Идиш
		"tosaigh", //Ирландский
		"framan", //Исландский
		"frente", //Испанский
		"davanti", //Итальянский
		"davant", //Каталонский
		"priekšā", //Латышский
		"priekyje", //Литовский
		"напред", //Македонский
		"quddiem", //Мальтийский
		"Vorderseite", //Немецкий
		"front", //Норвежский
		"przód", //Польский
		"frente", //Португальский
		"față", //Румынский
		"фронт", //Сербский
		"vpredu", //Словацкий
		"spredaj", //Словенский
		"перед", //Украинский
		"edessä", //Финский
		"devant", //Французский
		"ispred", //Хорватский
		"přední", //Чешский
		"främre", //Шведский
		"ees", //Эстонский
		"ön", //Азербайджанский
		"ճակատ", //Армянский
		"সামনে", //Бенгальский
		"ရှေ့", //Бирманский
		"đằng trước", //Вьетнамский
		"წინა", //Грузинский
		"આગળ", //Гуджарати
		"алдыңғы", //Казахский
		"ಮುಂಭಾಗ", //Каннада
		"正面", //Китайский (Традиционный)
		"正面", //Китайский (Упрощенный)
		"앞쪽", //Корейский
		"ខាងមុខ", //Кхмерский
		"ດ້ານໜ້າ", //Лаосский
		"മുന്നിൽ", //Малаялам
		"समोर", //Маратхи
		"урд", //Монгольский
		"अगाडि", //Непальский
		"ඉදිරිපස", //Сингальский
		"пеш", //Таджикский
		"ด้านหน้า", //Тайский
		"முன்", //Тамильский
		"ముందు", //Телугу
		"ön", //Турецкий
		"old", //Узбекский
		"سامنے", //Урду
		"सामने", //Хинди
		"pem hauv ntej", //Хмонг
		"フロント", //Японский
		"أمام", //Арабский
		"חֲזִית", //Иврит
		"جلو", //Персидский
		"voor", //Африкаанс
		"ngaphambili", //Зулу
		"n'ihu", //Игбо
		"iwaju", //Йоруба
		"ka pele", //Сесото
		"hore", //Сомалийский
		"mbele", //Суахили
		"gaba", //Хауса
		"kutsogolo", //Чева
		"depan", //Индонезийский
		"anoloana", //Малагасийский
		"hadapan", //Малайский
		"mua", //Маори
		"atubangan", //Себуано
		"harap", //Филиппинский
		"ngarep", //Яванский
		"devan", //Гаитянский Креольский
		"front", //Латынь
		"fronto", //Эсперанто
	],
};

export default cameraLanguage;
